import { Button, Icon, Typography } from "@/components/atoms";
import { StaticSetupPanel } from "../StaticSetupPanel";
import { DriverAppStep } from "../data/driverAppSteps";
import { PlatformPill } from "./PlatformPill";
import { StepBreadcrumb } from "./StepBreadcrumb";

export interface DriverAppStepCardProps {
  step: DriverAppStep;
  isCompleted: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

export const DriverAppStepCard = ({ step, isCompleted, isOpen, onToggle }: DriverAppStepCardProps) => {
  const { stepNumber, title, icon, label, body, breadcrumb, helpOptions } = step;

  return (
    <StaticSetupPanel
      stepNumber={stepNumber}
      title={title}
      stepCount={1}
      completedSteps={isCompleted ? 1 : 0}
      badge={<PlatformPill platform="mobile" />}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="flex flex-col gap-4 rounded-lg border border-neutral-mid-gray px-5 py-4">
        <div className="flex gap-4">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded bg-primary-light">
            <Icon name={icon} size="lg" className="text-primary-dark" />
          </div>
          <div className="flex flex-col gap-1">
            <Typography variant="action" className="text-neutral-dark-gray">
              {label}
            </Typography>
            <Typography variant="paragraph" className="text-neutral-dark-gray">
              {body}
            </Typography>
          </div>
        </div>

        {helpOptions && helpOptions.length > 0 && (
          <div className="flex flex-wrap gap-2 md:gap-6">
            {helpOptions.map((option) => (
              <Button
                key={option.label}
                onClick={option.onClick}
                variant="tertiary-light"
                size="xs"
                endIcon={option.icon}
                className="!p-0 text-neutral-silver-gray hover:bg-white hover:text-neutral-dark-gray"
              >
                {option.label}
              </Button>
            ))}
          </div>
        )}

        <StepBreadcrumb segments={breadcrumb} />
      </div>
    </StaticSetupPanel>
  );
};
